import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {CrudUserService} from '../../../../shared/services/crud-user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserinfoInterface} from '@models/sharedinterface';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ShareddataService} from '@shared/services/shareddata.service';
import {Location} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {GlobalsService} from '@shared/services/globals.service';
import {CrudLanguagesService} from '@shared/services/crud-languages.service';
import {CrudTitlesService} from '@shared/services/crud-titles.service';
import {AbstractCrudEditComponent} from '../../../../shared/library/crud-library/abstract-crud-edit.component';
import {AlertService} from '../../../../shared/services/alert.service';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
  styleUrls: ['./users-edit.component.scss']
})
export class UsersEditComponent extends AbstractCrudEditComponent implements OnInit {

  confirmDialog: BsModalRef;

  listOfMandants: [];
  listOfRoles: [];
  listOfTools: any[];
  listOfCavokUserGroups: any[];
  onUserToolChangeMessage: string;

  warningMessageShown = false;

  serverRoot: string;

  @ViewChild('confirmtemplate') confirmModal: TemplateRef<any>;

  constructor(
    protected httpcrud: CrudUserService, // Specific
    protected httplanguagescrud: CrudLanguagesService, // Specific
    protected httptitlescrud: CrudTitlesService, // Specific
    protected route: ActivatedRoute,
    protected router: Router,
    protected sharedData: ShareddataService,
    protected location: Location,
    protected modalService: BsModalService,
    protected http: HttpClient,
    protected alertService: AlertService,
    protected apifactory: ApiFactoryService,
    private globalsservice: GlobalsService
  ) {

    super(route, router, apifactory, httpcrud, alertService);

    // TODO
    // needs to set the form fields later on because some data are attached to the user entity.
    // This should be removed by using multiple services instead.
    this.fields = [];

    this.entityrooturl = '/admin/users';
    this.createSectionTitle = 'Create user';
    this.updatePrefixTitle = 'Edit user: ';

    this.serverRoot = this.globalsservice.getBffapiroot();

  }

  ngOnInit(): void {
    // Gets languages if not already fetched
    if (this.sharedData.getLanguages().length === 0) {
      this.httplanguagescrud.getEntities().subscribe(({results}) => {
        this.sharedData.setLanguages(results);
      });
    }

    // Gets titles if not already fetched
    if (this.sharedData.getTitles().length === 0) {
      this.httptitlescrud.getEntities().subscribe(({results}) => {
        this.sharedData.setTitles(results);
      });
    }

    // Gets the users if not already fetched
    if (this.sharedData.getUsers(null, null).length === 0) {
      this.httpcrud.getEntities().subscribe(({results}) => {
        this.sharedData.setUsers(results);
      });
    }

    super.ngOnInit();
  }

  onInitCavokUserGroup = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    typedField.templateOptions.options = this.listOfCavokUserGroups;
  }

  onInitToolList = (field: any) => {
    const typedField: Required<FormlyFieldConfig> = field;
    typedField.props.options = this.listOfTools;
    if (this.model.useroldtools) {
      const previousTools = this.listOfTools.filter(t => this.model.useroldtools.indexOf(t.id) !== -1).map(t => t.keyword).join(', ');
      typedField.props.onChangeMessage = 'Previous: ' + previousTools;
    }
  }

  getAndConfigureEmptyDynamicFields() {
    this.httpcrud.getAdminUserDynamicFormData().subscribe( (data) => {
      this.setFields();

      this.listOfTools = data.results.tools;
      this.listOfCavokUserGroups = data.results.cavokusergroups;

      this.setMandantRoleAndUserToolsConfigs(data.results);
    });
  }

  getModelAndConfigureDynamicFields(entityid: string = '') {

    this.httpcrud.getEntity(entityid).subscribe( (data) => {
      this.model = data.results;
      this.model.showAllMandantRoles = true;

      // console.log(this.model.last_login);

      // converts the utc date to client's local
      this.model.last_login = this.model.last_login !== null ?
        this.globalsservice.convertDateFormatFromDb(this.model.last_login.date, 'YYYY-MM-DD HH:mm:ss') : '';

      // console.log(this.model.last_login);

      this.setFields();

      this.listOfTools = data.results.tools;
      this.listOfCavokUserGroups = data.results.cavokusergroups;

      this.setMandantRoleAndUserToolsConfigs(data.results);

      this.sharedData.setSelectedUser(this.model);

      this.sectionTitle = `${this.updatePrefixTitle} ${this.model.username}`;

    });

  }

  setMandantRoleAndUserToolsConfigs(fieldConfigs: UserinfoInterface) {
    // mandant role
    this.fields[0].fieldGroup[1].fieldGroup[2].fieldGroup = this.getMandantRolesFieldGroupConfig(fieldConfigs);
  }

  getMandantRolesFieldGroupConfig(fieldConfigs: any) {

    const mandants = fieldConfigs.mandants;

    const roles = fieldConfigs.roles;

    const mandantroles = [];

    for (const mandant of mandants) {

      mandantroles.push({
        key: mandant.id,
        type: 'ng-select',
        props: {
          label: mandant.label,
          multiple: true,
          closeOnSelect: false,
          options: roles.map(r => ({id: r.id, label: r.label}))
        },
        hideExpression: (model: any, formState: any, field: FormlyFieldConfig) => {
          return !this.model.showAllMandantRoles && this.model.mandantroles[String(mandant.id)] === undefined;
        },
        // expressions: {
        //   hide: (field: FormlyFieldConfig) => {
        //     return !field.model.showAllMandantRoles && this.model.mandantroles[String(mandant.id)] === undefined;
        //   },
        // }
      });

    } // for

    return mandantroles;

  } // getMandantRolesFieldGroupConfig

  // onRemoveTool($event) {
  onRemoveTool = ($event) => {
    console.log($event);
    if (!this.warningMessageShown) {
      this.confirmDialog = this.modalService.show(this.confirmModal);
      this.warningMessageShown = true;
    }
  }

  closeConfirmRemoveDialog() {
    this.confirmDialog.hide();
  }

  toggleAllMandantRoles() {
    this.model.showAllMandantRoles = !this.model.showAllMandantRoles;
  }

  onCancel() {
    this.router.navigate([this.entityrooturl]);
  } // onCancel

  goBack() {
    this.location.back();
  } // onCancel

  private setFields() {
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-md-6 col-sm-12',
            fieldGroup: [
              {
                wrappers: ['card-wrapper'],
                templateOptions: {
                  label: 'Credentials',
                  className: 'mt-3'
                },
                fieldGroup: [
                  {
                    key: 'username',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {
                      label: 'Username',
                      required: true,
                      readonly: this.entityid ? true : false
                    },
                    validators: {
                      username: {
                        expression: (c: AbstractControl) => {
                          if (this.entityid) {
                            return true;
                          }
                          return this.sharedData.getUsers(null, null).filter(u => u.username === c.value).length === 0;
                        },
                        message: (error: any, field: FormlyFieldConfig) => `username ${field.formControl.value} is already taken`,
                      },
                    },
                  },
                  {
                    key: 'password',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {
                      label: 'Password',
                      type: 'password',
                      required: !this.entityid ? true : false
                    },
                    validators: {
                      password: {
                        expression: (c) => {
                          if (this.entityid && c.value === '') {
                            return true;
                          }
                          // tslint:disable-next-line:max-line-length
                          return /^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z])(?=.*[§°+¦"@*#ç°%§&¬/¢()=?´`~\]\[!\-_^{},.:;/\\<>]).{12,}$/.test(c.value);
                        },
                        message: (error: any, field: FormlyFieldConfig) => `Password too weak.\n12 characters minimum\nAt least 1 number\nAt least 1 uppercase letter\nAt least 1 lowercase letter\nAt least 1 special character`,
                      },
                    },
                  },
                  {
                    key: 'last_login',
                    type: 'datepicker',
                    defaultValue: '',
                    templateOptions: {
                      label: 'Last login',
                      disabled: true,
                      readonly: true,
                      format: 'YYYY-MM-DD HH:mm:ss'
                    }
                  },
                  {
                    key: 'active',
                    type: 'checkbox',
                    defaultValue: true,
                    templateOptions: {label: 'Active'}
                  },
                  {
                    key: 'cavokusergroup',
                    type: 'ng-select2',
                    templateOptions: {label: 'Cavok user group (the synchronisation of cavok group and credentials in cavok works only if the user is related to imagebank, cavok and aos tools)', clearable: true},
                    hooks: {
                      onInit: this.onInitCavokUserGroup
                    }
                  },
                ]
              },
              {
                wrappers: ['card-wrapper'],
                templateOptions: {
                  label: 'User info',
                  className: 'mt-3'
                },
                fieldGroup: [
                  {
                    key: 'fkTitleId',
                    type: 'ng-select',
                    defaultValue: this.sharedData.getTitles()[0]?.id,
                    templateOptions: {
                      required: true,
                      label: 'Title',
                      closeOnSelect: true,
                      options: this.sharedData.getTitles()
                    }
                  },
                  {
                    key: 'first_name',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'First name', required: true}
                  },
                  {
                    key: 'last_name',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'Last name', required: true}
                  },
                  {
                    key: 'email',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'E-mail', required: true}
                  },
                  {
                    key: 'phone',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'Phone'}
                  },
                  {
                    key: 'mobile',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'Mobile'}
                  },
                  {
                    key: 'position',
                    type: 'input',
                    defaultValue: '',
                    templateOptions: {label: 'Position'}
                  },
                  {
                    key: 'fkLangId',
                    type: 'ng-select',
                    defaultValue: this.sharedData.getLanguages()[0]?.id,
                    templateOptions: {
                      required: true,
                      label: 'Language',
                      closeOnSelect: true,
                      options: this.sharedData.getLanguages()
                    }
                  },
                  {
                    key: 'uploadquota',
                    type: 'input',
                    templateOptions: {
                      label: 'Custom upload quota (MB)',
                      readonly: false // TODO: only admin
                    }
                  }
                ]
              }
            ]
          },
          {
            className: 'col-md-6 col-sm-12',
            fieldGroup: [
              {
                wrappers: ['card-wrapper'],
                templateOptions: {
                  label: 'Contact Nr',
                  className: 'mt-3'
                },
                fieldGroup: [
                  {
                    key: 'contactNr',
                    type: 'input',
                    defaultValue: ''
                  }
                ]
              },
              {
                key: 'usertools',
                type: 'ng-select',
                wrappers: ['card-wrapper'],
                props: {
                  link: this.entityrooturl + '/' + this.entityid + '/usertoolconfigs',
                  linkLabel: 'Edit user tools',
                  label: 'Tools',
                  className: 'mt-3',
                  multiple: true,
                  bindLabel: 'keyword',
                  onRemove: ($event) => this.onRemoveTool($event)
                },
                hooks: {
                  onInit: this.onInitToolList
                }
              },
              {
                key: 'mandantroles',
                wrappers: ['card-wrapper'],
                props: {
                  label: 'Roles',
                  className: 'mt-3',
                  buttonLabel: 'Add role',
                  onButtonClick: () => this.toggleAllMandantRoles(),
                },
                expressionProperties: {
                  'templateOptions.buttonLabel': (model: any, formState: any, field: FormlyFieldConfig) => {
                    // access to the main model can be through `this.model` or `formState` or `model
                    return this.model.showAllMandantRoles ? 'Close' : 'Add role';
                  }
                },
                expressions: {
                  // 'templateOptions.buttonLabel': (model: any, formState: any, field: FormlyFieldConfig) => {
                  //   // access to the main model can be through `this.model` or `formState` or `model
                  //   return this.model.showAllMandantRoles ? 'Close' : 'Add role';
                  // },
                  hide: (field: FormlyFieldConfig) => {
                    return false;
                  },
                },
                fieldGroup: []  // set later
              }
            ]
          }
        ]
      },
    ];
    this.setReady();
  }
}
